{
  "SEARCH": {
    "TABS": {
      "ALL": "Allemaal",
      "CONTACTS": "Contacten",
      "CONVERSATIONS": "Gesprekken",
      "MESSAGES": "Berichten"
    },
    "SECTION": {
      "CONTACTS": "Contacten",
      "CONVERSATIONS": "Gesprekken",
      "MESSAGES": "Berichten"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Zoeken",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "Geen {item} gevonden voor query '{query}'",
    "EMPTY_STATE_FULL": "Geen resultaten gevonden voor query '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ om te focussen",
    "INPUT_PLACEHOLDER": "Voer 3 of meer tekens in om te zoeken",
    "RECENT_MESSAGES": "Mijn recent verzonden berichten",
    "EMPTY_STATE_DEFAULT": "Zoeken op gesprek id, e-mail, telefoonnummer, berichten voor betere zoekresultaten. ",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Meer lezen",
    "WROTE": "schreef:",
    "FROM": "van",
    "EMAIL": "e-mailadres",
    "EMAIL_SUBJECT": "onderwerp"
  }
}
